import React, { useState, useEffect } from "react";
import "./BriefForm.css";
import { BriefDetailsUI } from "./BriefDetailsUI";
import { EvaluationInformationUI } from "./EvaluationInformationUI";
import { ProducerInformation } from "./ProducerInformation";

const BriefForm = ({
  propsData,
  formData,
  handleDropdown,
  handleTextAreaSelection,
  handleInfo,
  handleDatePicker,
  handleCheckboxData,
  saveAction,
  addCriterionAction,
  handleBriefDetailsData,
  hanleEvaluationData,
  handleProducerData,
}) => {
  const [closedBrief, setClosedBrief] = useState(false);
  const [isCloseDateChange, setCloseDateChange] = useState(false);
  const handleRadioButton = (type, title) => {
    if (type === 2) {
      setClosedBrief(true);
    } else {
      setClosedBrief(false);
    }
  };

  useEffect(() => {
    setCloseDateChange(false);
  }, [isCloseDateChange]);

  const onCloseDateChange = () => {
    setCloseDateChange(true);
  };

  return (
    <div className="brief___form">
      <BriefDetailsUI
        propsData={propsData}
        handleTitleSelection={handleDropdown}
        handleTextArea={handleTextAreaSelection}
        handleDate={handleDatePicker}
        handleInfo={handleInfo}
        handleOnCloseDateChange={onCloseDateChange}
        handleBriefDetailsData={(data) => handleBriefDetailsData(data)}
      />
      <EvaluationInformationUI
        propsData={propsData}
        checkData={formData}
        isCloseDateChange={isCloseDateChange}
        handleTitleSelection={handleDropdown}
        handleDate={handleDatePicker}
        handleTextArea={handleTextAreaSelection}
        saveAction={saveAction}
        addCriterionAction={addCriterionAction}
        handleCheckbox={handleCheckboxData}
        hanleEvaluationData={(data) => hanleEvaluationData(data)}
      />
      <ProducerInformation
        propsData={propsData}
        closedBrief={closedBrief}
        handleRadioButton={handleRadioButton}
        handleTitleSelection={handleDropdown}
        handleProducerData={(data) => handleProducerData(data)}
      />
    </div>
  );
};

export default BriefForm;
